import { LayerSpecification } from "maplibre-gl";
import { EMBED_ORIGIN } from "./uvis-definition";

export const EVENT_DETOUR_LINE: LayerSpecification = {
	id: "event-detour-layer-line",
	type: "line",
	source: "pgtiles",
	"source-layer": "public.kafkamessages_notplannedevent_detour_public",
	layout: {
		"line-join": "round",
		"line-cap": "round",
	},
	filter: [
		"any",
		["all", ["==", ["get", "restrictions"], "['roadBlocked']"], ["==", ["get", "status"], "ACTIVE"]],
		[
			"all",
			[
				"any",
				["==", ["get", "datex_subclass"], "accidentType"],
				["all", ["==", ["get", "datex_subclass"], "obstructionType"], ["==", ["get", "datex_enum"], "rescueAndRecoveryWork"]],
				["all", ["==", ["get", "datex_subclass"], "obstructionType"], ["==", ["get", "datex_enum"], "unprotectedAccidentArea"]],
			],
			["!=", ["get", "restrictions"], "['roadBlocked']"],
		],
		[
			"all",
			[
				"any",
				["==", ["get", "datex_subclass"], "nonWeatherRelatedRoadConditionType"],
				["==", ["get", "datex_subclass"], "animalPresenceType"],
				["==", ["get", "datex_subclass"], "infrastructureDamageType"],
				["==", ["get", "datex_subclass"], "vehicleObstructionType"],
				["==", ["get", "datex_subclass"], "environmentalObstructionType"],
				["all", ["==", ["get", "datex_subclass"], "obstructionType"], ["!=", ["get", "datex_enum"], "unprotectedAccidentArea"]],
			],
			["!=", ["get", "restrictions"], "['roadBlocked']"],
		],
	],
	paint: {
		"line-color": ["case", ["boolean", ["feature-state", "highlighted"], false], "#00ccf5", "#F7B513"],
		"line-width": ["interpolate", ["linear"], ["zoom"], 10, 5, 16, 12],
	},
};

// Add a symbol layer for arrows
export const EVENT_DETOUR_ARROWS: LayerSpecification = {
	id: "event-detour-layer-arrows",
	type: "symbol",
	source: "pgtiles",
	"source-layer": "public.kafkamessages_notplannedevent_detour_public",
	filter: [
		"any",
		["all", ["==", ["get", "restrictions"], "['roadBlocked']"], ["==", ["get", "status"], "ACTIVE"]],
		[
			"all",
			[
				"any",
				["==", ["get", "datex_subclass"], "accidentType"],
				["all", ["==", ["get", "datex_subclass"], "obstructionType"], ["==", ["get", "datex_enum"], "rescueAndRecoveryWork"]],
				["all", ["==", ["get", "datex_subclass"], "obstructionType"], ["==", ["get", "datex_enum"], "unprotectedAccidentArea"]],
			],
			["!=", ["get", "restrictions"], "['roadBlocked']"],
		],
		[
			"all",
			[
				"any",
				["==", ["get", "datex_subclass"], "nonWeatherRelatedRoadConditionType"],
				["==", ["get", "datex_subclass"], "animalPresenceType"],
				["==", ["get", "datex_subclass"], "infrastructureDamageType"],
				["==", ["get", "datex_subclass"], "vehicleObstructionType"],
				["==", ["get", "datex_subclass"], "environmentalObstructionType"],
				["all", ["==", ["get", "datex_subclass"], "obstructionType"], ["!=", ["get", "datex_enum"], "unprotectedAccidentArea"]],
			],
			["!=", ["get", "restrictions"], "['roadBlocked']"],
		],
	],
	layout: {
		"symbol-placement": "line",
		"symbol-spacing": 20,
		"icon-image": "bultinja-apvedceljsh",
		"icon-size": ["interpolate", ["linear"], ["zoom"], 10, 0.4, 16, 0.8],
		"icon-rotate": 0,
		"icon-allow-overlap": true,
	},
};

export const EVENT_DETOUR_LINE_ALT: LayerSpecification = {
	id: "event-detour-layer-line-alt",
	type: "line",
	source: "pgtiles",
	"source-layer": "public.kafkamessages_plannedevent_detour_public",
	layout: {
		"line-join": "round",
		"line-cap": "round",
	},
	filter: [
		"any",
		["all", ["==", ["get", "restrictions"], "['roadBlocked']"], ["==", ["get", "status"], "ACTIVE"]],
		[
			"all",
			[
				"any",
				["==", ["get", "datex_subclass"], "accidentType"],
				["all", ["==", ["get", "datex_subclass"], "obstructionType"], ["==", ["get", "datex_enum"], "rescueAndRecoveryWork"]],
				["all", ["==", ["get", "datex_subclass"], "obstructionType"], ["==", ["get", "datex_enum"], "unprotectedAccidentArea"]],
			],
			["!=", ["get", "restrictions"], "['roadBlocked']"],
		],
		["all", ["==", ["get", "datex_subclass"], "massEvent"], ["!=", ["get", "restrictions"], "['roadBlocked']"], ["==", ["get", "status"], "ACTIVE"]],
		[
			"all",
			["==", ["get", "event_subclass"], EMBED_ORIGIN === "map-test.lvceli.lv" ? "constructionWork" : "constructionWorkType"],
			["==", ["get", "event_enum"], "constructionWork"],
			[
				"all",
				["!", ["==", ["get", "construction_paused"], true]],
				["any", ["!", ["has", "notes"]], ["!", ["in", "tehnoloģiskais pārtraukums", ["downcase", ["get", "notes"]]]]],
			],
			["!", ["==", ["get", "status"], "PLANNED"]],
		],
		[
			"all",
			["==", ["get", "event_subclass"], EMBED_ORIGIN === "map-test.lvceli.lv" ? "constructionWork" : "constructionWorkType"],
			["==", ["get", "event_enum"], "constructionWork"],
			["any", ["all", ["has", "notes"], ["in", "tehnoloģiskais pārtraukums", ["downcase", ["get", "notes"]]]], ["boolean", ["get", "construction_paused"]]],
		],
	],
	paint: {
		"line-color": ["case", ["boolean", ["feature-state", "highlighted"], false], "#00ccf5", "#F7B513"],
		"line-width": ["interpolate", ["linear"], ["zoom"], 10, 5, 16, 12],
	},
};

// Add a symbol layer for arrows
export const EVENT_DETOUR_ARROWS_ALT: LayerSpecification = {
	id: "event-detour-layer-arrows-alt",
	type: "symbol",
	source: "pgtiles",
	"source-layer": "public.kafkamessages_plannedevent_detour_public",
	layout: {
		"symbol-placement": "line",
		"symbol-spacing": 20,
		"icon-image": "bultinja-apvedceljsh",
		"icon-size": ["interpolate", ["linear"], ["zoom"], 10, 0.4, 16, 0.8],
		"icon-rotate": 0,
		"icon-allow-overlap": true,
	},
	filter: [
		"any",
		["all", ["==", ["get", "restrictions"], "['roadBlocked']"], ["==", ["get", "status"], "ACTIVE"]],
		[
			"all",
			[
				"any",
				["==", ["get", "datex_subclass"], "accidentType"],
				["all", ["==", ["get", "datex_subclass"], "obstructionType"], ["==", ["get", "datex_enum"], "rescueAndRecoveryWork"]],
				["all", ["==", ["get", "datex_subclass"], "obstructionType"], ["==", ["get", "datex_enum"], "unprotectedAccidentArea"]],
			],
			["!=", ["get", "restrictions"], "['roadBlocked']"],
		],
		["all", ["==", ["get", "datex_subclass"], "massEvent"], ["!=", ["get", "restrictions"], "['roadBlocked']"], ["==", ["get", "status"], "ACTIVE"]],
		[
			"all",
			["==", ["get", "event_subclass"], EMBED_ORIGIN === "map-test.lvceli.lv" ? "constructionWork" : "constructionWorkType"],
			["==", ["get", "event_enum"], "constructionWork"],
			[
				"all",
				["!", ["==", ["get", "construction_paused"], true]],
				["any", ["!", ["has", "notes"]], ["!", ["in", "tehnoloģiskais pārtraukums", ["downcase", ["get", "notes"]]]]],
			],
			["!", ["==", ["get", "status"], "PLANNED"]],
		],
		[
			"all",
			["==", ["get", "event_subclass"], EMBED_ORIGIN === "map-test.lvceli.lv" ? "constructionWork" : "constructionWorkType"],
			["==", ["get", "event_enum"], "constructionWork"],
			["==", ["get", "status"], "PLANNED"],
		],
		[
			"all",
			["==", ["get", "event_subclass"], EMBED_ORIGIN === "map-test.lvceli.lv" ? "constructionWork" : "constructionWorkType"],
			["==", ["get", "event_enum"], "constructionWork"],
			["any", ["all", ["has", "notes"], ["in", "tehnoloģiskais pārtraukums", ["downcase", ["get", "notes"]]]], ["boolean", ["get", "construction_paused"]]],
		],
	],
};
